import { isPlatformServer } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { sleep } from 'src/app/lib/sleep';
import { AppConfigService } from 'src/app/providers/config.service';
import { BrowserService } from 'src/app/services/browser.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard {
  constructor(
    private config: AppConfigService,
    private browserService: BrowserService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;
    const returnUrl = next.queryParams.returnUrl?.replace(/\?$/, '') || this.browserService.getCorrectPicflowUrl();
    try {
      await sleep(1000 * 2);
      await lastValueFrom(
        this.http.get(`${this.config.apiEndpoint}/profile?ignore_401_error=true&ignore_503_error=true`) // TODO: use a dedicated endpoint for this
      );
      location.href = returnUrl;
      return false;
    } catch (err) {
      if (!(err instanceof HttpErrorResponse)) throw err;
      if (err.status === 503) return true;
      location.href = returnUrl;
    }
  }
}
